import useGet from "./useGet";
import {store} from "../App";
import { getDeckNumber } from "../utils/miscUtils";

const useTravelDocs = (hash) => {

    const {passenger: passengers, cabinInformation, luggageTagInformation, tableInformation, ...bookingData} =
        useGet(hash ? `precruise/guest/travelDocs/${hash}` :'precruise/travelDocs', {
            passenger: null,
            cabinInformation: null,
            luggageTagInformation: null,
            cabinAllocated: null,
            tableInformation: null,
        });

    bookingData.bookingSubType = store.getState().authentication?.bookingSubType;
    bookingData.shipBerthed = cabinInformation?.shipBerthed || "";
    bookingData.shipPhone = cabinInformation?.shipPhone || "";
    if(!passengers) {
        return {passengers, bookingData};
    }

    // make a map of external IDs for simple reference when adding cabin info to pax and save the first phone number
    let phoneNumber = "";
    const passengerExternalIds = new Map();
    passengers.forEach((passenger, index) => {
        if(!phoneNumber && passenger.mobileNumber) {
            phoneNumber = passenger.mobileNumber;
        }
        passengerExternalIds.set(passenger.externalId, index);
    });

    // add the found phone number to all passengers
    passengers.forEach((passenger) => {
        passenger.mobileNumber = phoneNumber;
    });


    // loop over all cabins and over all pax in the cabin and add that data to the pax info
    if(cabinInformation && cabinInformation.cabin) {
        cabinInformation.cabin.forEach(cabin => {
            const deckNumber = getDeckNumber(cabin);

            cabin.passengerId.forEach(passengerId => {
                const passengerIndex = passengerExternalIds.get(passengerId+"");
                passengers[passengerIndex].cabinNumber = cabin.cabinNumber;
                passengers[passengerIndex].deckNumber = deckNumber;
                passengers[passengerIndex].cabinCategory = cabin.cabinCategory;
                passengers[passengerIndex].embarkationTime = cabin.embarkationTime;
                passengers[passengerIndex].embarkationClosingTime = cabin.embarkationClosingTime;


            });
        })
    }

    // loop over all luggagetag information to determine what pages should be generated
    if(luggageTagInformation && luggageTagInformation.luggageTag) {
        luggageTagInformation.luggageTag.forEach(luggageInfo => {
            const passengerIndex = passengerExternalIds.get(luggageInfo.paxId);
            passengers[passengerIndex].wheelchairTag = luggageInfo.WheelChairTag;
            passengers[passengerIndex].priorityEmbarkation = luggageInfo.LuggageTagText === "Priority";
            passengers[passengerIndex].disembarkationText = luggageInfo.DisembarkationTagText;
        })
    }

    // loop over the table information
    if(tableInformation?.tableAllocation) {
        tableInformation.tableAllocation.forEach(table => {
            table.passengerId.forEach(passengerId => {
                const passengerIndex = passengerExternalIds.get(passengerId+"");
                passengers[passengerIndex].tableNumber = table.tableNumber;
                passengers[passengerIndex].restaurantName = tableInformation.restaurantName;
                passengers[passengerIndex].embarkationTime = tableInformation.Embark_Time;
                passengers[passengerIndex].embarkationGroup = tableInformation.Embark_Group;
                passengers[passengerIndex].confirmedSitting = tableInformation.Confirmed_Sitting;
                passengers[passengerIndex].confirmedSittingTime = tableInformation.Confirmed_Sitting_Time;
            });
        });
    }

    return {passengers, bookingData}
}

export default useTravelDocs;